import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context18; _forEachInstanceProperty(_context18 = ownKeys(Object(source), true)).call(_context18, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context19; _forEachInstanceProperty(_context19 = ownKeys(Object(source))).call(_context19, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useRef, useMemo, useCallback, useEffect, useState, createContext } from 'react';
import { RecoilRoot, selectorFamily, useRecoilValue, useRecoilCallback } from 'recoil';
import flatten from 'flat';
import { actionsAtom, formSelector } from './react-forms';
import { useActions } from './hooks/use-actions';
import { uuid } from './utils';
import { get, set, merge, reduce, isFunction, noop } from 'lodash';
var MultiFormContext = /*#__PURE__*/createContext({});
var MultiFormVolatileContext = /*#__PURE__*/createContext({});
var MultiFormProvider = MultiFormContext.Provider;
var MultiFormVolatileProvider = MultiFormVolatileContext.Provider;

function createValidator(_ref) {
  var getFormState = _ref.getFormState,
      validate = _ref.validate;
  return reduce(flatten(validate !== null && validate !== void 0 ? validate : {}), function (acc, validateFn, name) {
    return set(acc, name, function (values) {
      var _context;

      var forms = getFormState();
      var allValues = reduce(forms, function (acc, form) {
        return _objectSpread(_objectSpread({}, acc), _valuesInstanceProperty(form));
      }, {});
      var allChangedValues = reduce(forms, function (acc, form) {
        var changedValues = reduce(flatten(form.isChanged), function (acc, isChanged, name) {
          if (isChanged) {
            set(acc, name, get(_valuesInstanceProperty(form), name));
          }

          return acc;
        }, {});
        return merge(acc, changedValues);
      }, {});

      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }

      return validateFn.apply(void 0, _concatInstanceProperty(_context = [merge({}, allValues, values, allChangedValues)]).call(_context, rest));
    });
  }, {});
}

var multiFormSelector = selectorFamily({
  key: 'allForms',
  get: function get(_ref2) {
    var id = _ref2.id,
        _ref2$configs = _ref2.configs,
        configs = _ref2$configs === void 0 ? [] : _ref2$configs;
    return function (_ref3) {
      var recoilGet = _ref3.get;
      return _reduceInstanceProperty(configs).call(configs, function (acc, _ref4) {
        var formId = _ref4.id,
            names = _ref4.names,
            initialValues = _ref4.initialValues;
        acc[formId] = recoilGet(formSelector({
          groupId: id,
          id: formId,
          names: names,
          initialValues: initialValues
        }));
        return acc;
      }, {});
    };
  }
});
var isSubmittingSelector = selectorFamily({
  key: 'allFormsIsSubmitting',
  get: function get(_ref5) {
    var id = _ref5.id,
        _ref5$configs = _ref5.configs,
        configs = _ref5$configs === void 0 ? [] : _ref5$configs;
    return function (_ref6) {
      var _context2;

      var recoilGet = _ref6.get;
      var allForms = recoilGet(multiFormSelector({
        id: id,
        configs: configs
      }));
      return _someInstanceProperty(_context2 = _Object$keys(allForms)).call(_context2, function (id) {
        var _allForms$id;

        return (_allForms$id = allForms[id]) === null || _allForms$id === void 0 ? void 0 : _allForms$id.isSubmitting;
      }, []);
    };
  }
});
var defaultForms = {};

/**
 * @param {*} forms - {
 *    [formId]: {
 *      names,
 *      initialValues,
 *      validate,
 *      handleSubmit
 *    }
 *  }
 */
function MultiFormInner(_ref7) {
  var propId = _ref7.id,
      _ref7$formConfigs = _ref7.formConfigs,
      propFormConfigs = _ref7$formConfigs === void 0 ? defaultForms : _ref7$formConfigs,
      children = _ref7.children,
      render = _ref7.render;
  var id = useRef(propId !== null && propId !== void 0 ? propId : uuid());

  var _useActions = useActions(),
      createHelpers = _useActions.createHelpers,
      _setName = _useActions.setName,
      _validateField = _useActions.validateField,
      validateForms = _useActions.validateForms,
      submitForms = _useActions.submitForms;

  var _useState = useState(propFormConfigs),
      _useState2 = _slicedToArray(_useState, 2),
      formConfigs = _useState2[0],
      setFormConfigs = _useState2[1];

  var configsForSelector = useMemo(function () {
    var _context3;

    return _mapInstanceProperty(_context3 = _Object$keys(formConfigs)).call(_context3, function (formId) {
      var _formConfigs$formId = formConfigs[formId],
          names = _formConfigs$formId.names,
          initialValues = _formConfigs$formId.initialValues;
      return {
        id: formId,
        names: names,
        initialValues: initialValues
      };
    });
  }, [formConfigs]);
  var getFormState = useRecoilCallback(function (_ref8) {
    var snapshot = _ref8.snapshot;
    return function () {
      return snapshot.getLoadable(multiFormSelector({
        id: id.current,
        configs: configsForSelector
      })).contents;
    };
  }, []);
  var configsWithValidate = useMemo(function () {
    var _context4;

    return _reduceInstanceProperty(_context4 = _Object$keys(formConfigs)).call(_context4, function (acc, id) {
      var _config$handleSubmit;

      var config = formConfigs[id];
      var validate = createValidator({
        getFormState: getFormState,
        validate: config === null || config === void 0 ? void 0 : config.validate
      });
      acc[id] = _objectSpread({
        validate: validate,
        handleSubmit: (_config$handleSubmit = config === null || config === void 0 ? void 0 : config.handleSubmit) !== null && _config$handleSubmit !== void 0 ? _config$handleSubmit : noop
      }, config);
      return acc;
    }, {});
  }, [formConfigs, getFormState]);
  var createFormActions = useCallback(function (_ref9) {
    var formId = _ref9.id,
        validate = _ref9.validate,
        handleSubmit = _ref9.handleSubmit;
    return _objectSpread(_objectSpread({}, createHelpers({
      groupId: id.current,
      id: formId
    })), {}, {
      setName: function setName() {
        var _context5;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _setName.apply(void 0, _concatInstanceProperty(_context5 = [{
          groupId: id.current,
          id: formId
        }]).call(_context5, args));
      },
      validateField: function validateField() {
        var _context6;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return _validateField.apply(void 0, _concatInstanceProperty(_context6 = [{
          groupId: id.current,
          id: formId,
          validate: validate
        }]).call(_context6, args));
      },
      validateForm: function () {
        var _validateForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref10) {
          var increaseSubmitCount, errors;
          return _regeneratorRuntime.wrap(function _callee$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  increaseSubmitCount = _ref10.increaseSubmitCount;
                  _context7.next = 3;
                  return validateForms({
                    groupId: id.current,
                    increaseSubmitCount: increaseSubmitCount
                  }, _defineProperty({}, formId, {
                    validate: validate
                  }));

                case 3:
                  errors = _context7.sent;
                  return _context7.abrupt("return", get(errors, formId));

                case 5:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee);
        }));

        function validateForm(_x) {
          return _validateForm.apply(this, arguments);
        }

        return validateForm;
      }(),
      submitForm: function () {
        var _submitForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var _context8;

          var _len4,
              args,
              _key4,
              submissions,
              _args2 = arguments;

          return _regeneratorRuntime.wrap(function _callee2$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  for (_len4 = _args2.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    args[_key4] = _args2[_key4];
                  }

                  _context9.next = 3;
                  return submitForms.apply(void 0, _concatInstanceProperty(_context8 = [{
                    groupId: id.current
                  }, _defineProperty({}, formId, {
                    validate: validate,
                    handleSubmit: handleSubmit
                  })]).call(_context8, args));

                case 3:
                  submissions = _context9.sent;
                  return _context9.abrupt("return", get(submissions, formId));

                case 5:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee2);
        }));

        function submitForm() {
          return _submitForm.apply(this, arguments);
        }

        return submitForm;
      }()
    });
  }, [createHelpers, _setName, _validateField, validateForms, submitForms]);
  var formState = useRecoilValue(multiFormSelector({
    id: id.current,
    configs: configsForSelector
  }));
  var formActions = useMemo(function () {
    var _context10;

    return _reduceInstanceProperty(_context10 = _Object$keys(configsWithValidate)).call(_context10, function (acc, id) {
      var config = configsWithValidate[id];
      acc[id] = createFormActions({
        id: id,
        validate: config === null || config === void 0 ? void 0 : config.validate,
        handleSubmit: config === null || config === void 0 ? void 0 : config.handleSubmit
      });
      return acc;
    }, {});
  }, [configsWithValidate, createFormActions]);
  var formsWithActions = useMemo(function () {
    var _context11;

    return _reduceInstanceProperty(_context11 = _Object$keys(formState)).call(_context11, function (acc, id) {
      acc[id] = _objectSpread(_objectSpread({}, formState[id]), formActions[id]);
      return acc;
    }, {});
  }, [formState, formActions]);
  var isSubmitting = useRecoilValue(isSubmittingSelector({
    id: id.current,
    configs: configsForSelector
  }));
  var resetAll = useCallback(function (values) {
    var _context12;

    _forEachInstanceProperty(_context12 = _Object$keys(formsWithActions)).call(_context12, function (id) {
      var _formsWithActions$id;

      var valuesByFormId = values === null || values === void 0 ? void 0 : values[id];
      (_formsWithActions$id = formsWithActions[id]) === null || _formsWithActions$id === void 0 ? void 0 : _formsWithActions$id.resetForm(valuesByFormId !== null && valuesByFormId !== void 0 ? valuesByFormId : values);
    });
  }, [formsWithActions]);
  var validateAll = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", validateForms({
              groupId: id.current,
              increaseSubmitCount: true
            }, configsWithValidate));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee3);
  })), [configsWithValidate, validateForms]);
  var submitAll = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _context14, _context15;

    var _len5,
        args,
        _key5,
        submissions,
        anySubmitFailed,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            for (_len5 = _args4.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = _args4[_key5];
            }

            _context16.next = 3;
            return submitForms.apply(void 0, _concatInstanceProperty(_context14 = [{
              groupId: id.current
            }, configsWithValidate]).call(_context14, args));

          case 3:
            submissions = _context16.sent;
            anySubmitFailed = _someInstanceProperty(_context15 = _Object$keys(submissions)).call(_context15, function (key) {
              return submissions[key] === false;
            });

            if (!anySubmitFailed) {
              _context16.next = 7;
              break;
            }

            return _context16.abrupt("return", false);

          case 7:
            return _context16.abrupt("return", submissions);

          case 8:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee4);
  })), [configsWithValidate, submitForms]);
  var setActions = useRecoilCallback( // TODO: Fix type
  function (_ref14) {
    var recoilSet = _ref14.set;
    return function (formId, actions) {
      recoilSet(actionsAtom({
        groupId: id.current,
        id: formId
      }), actions);
    };
  });
  useEffect(function () {
    var _context17;

    _forEachInstanceProperty(_context17 = _Object$keys(formActions)).call(_context17, function (id) {
      setActions(id, formActions[id]);
    });
  }, [formActions, setActions]);
  useEffect(function () {
    setFormConfigs(function (prevFormConfigs) {
      return merge({}, prevFormConfigs, propFormConfigs);
    });
  }, [propFormConfigs]);
  var props = useMemo(function () {
    return {
      forms: formsWithActions,
      isSubmitting: isSubmitting,
      resetAll: resetAll,
      validateAll: validateAll,
      submitAll: submitAll
    };
  }, [formsWithActions, isSubmitting, resetAll, validateAll, submitAll]);
  var value = useMemo(function () {
    return {
      id: id.current,
      formConfigs: formConfigs,
      setFormConfigs: setFormConfigs
    };
  }, [formConfigs]);
  return /*#__PURE__*/React.createElement(MultiFormProvider, {
    value: value
  }, /*#__PURE__*/React.createElement(MultiFormVolatileProvider, {
    value: props
  }, isFunction(children) ? children(props) : isFunction(render) ? render(props) : children));
}

export function MultiForm(props) {
  return /*#__PURE__*/React.createElement(RecoilRoot, null, /*#__PURE__*/React.createElement(MultiFormInner, props));
}
export { multiFormSelector, MultiFormContext, MultiFormVolatileContext };
export default MultiForm;